import * as React from 'react';
import { useFormValCtx } from '@/context/FormValCtx';
import { getOutput } from '@/utils/outputFn';
import { FormVals } from '../Form';
import { TFunction, useTranslation } from 'react-i18next';

import {
  DataGrid,
  GridColDef,
  GridValueFormatterParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import Radar from './Radar';

// export type Procedure = 'ATVM' | 'LSC' | 'SLFF' | 'ULS' | 'PTVM' | 'LEFORT';
export type Procedure = 'ATVM' | 'PTVM' | 'LSC' | 'ULS' | 'SLFF' | 'LEFORT';

export interface Row {
  id: number;
  Procedure: Procedure;
  Prior: number;
  Operability: number;
  Effectiveness: number;
  Safety: number;
  Economy: number;
  Recommendation: number;
}

function createRow(
  id,
  Procedure,
  Prior,
  Operability,
  Effectiveness,
  Safety,
  Economy,
  Recommendation,
): Row {
  return {
    id,
    Procedure,
    Prior,
    Operability,
    Effectiveness,
    Safety,
    Economy,
    Recommendation,
  };
}

// rersult 中術式的順序對應excel
//  0 .   1 .   2 .  3 .  4 .    5 .
// [ATVM, LSC, SLFF, ULS, PTVM, LEFORT]
function creatRows(
  formVals: FormVals,
  t: TFunction<'translation', undefined>,
): Row[] {
  const output = getOutput(formVals);
  // console.log(formVals);

  const excelIndex = {
    ATVM: 0,
    PTVM: 1,
    LSC: 2,
    ULSTOP: 3,
    SLFFTOP: 4,
    LEFORT: 5,
  };

  const rows: Row[] = [];

  Object.entries(excelIndex).forEach(([key, idx]) => {
    rows.push(
      createRow(
        idx,
        key,
        output.Prior_result[idx],
        output.Operability_result[idx],
        output.Effectiveness_result[idx],
        output.Safety_result[idx],
        output.Economy_result[idx],
        output.Recommend_Result[idx],
      ),
    );
  });

  // rows.sort((a, b) => b.Recommendation - a.Recommendation);
  rows.sort((a, b) => b.id + a.id);

  return rows;
}

const valueFormatter = (params: GridValueFormatterParams) => {
  return Math.round((params.value as number) * 100) + '%';
};

export default function DataTable() {
  const { t } = useTranslation();
  const { formVals } = useFormValCtx();

  const rows = creatRows(formVals, t);
  console.log(rows, formVals, t);

  const columns: GridColDef[] = [
    {
      field: 'Procedure',
      headerName: t('Procedure'),
      width: 200,
      sortable: false,
      renderCell: (row) => {
        return (
          <div
            style={{
              whiteSpace: 'pre-wrap',
            }}
          >
            {t(row.value)}
          </div>
        );
      },
      headerClassName: 'table-title',
    },
    {
      field: 'Recommendation',
      headerName: t('RecommendationProbability'),
      type: 'number',
      valueFormatter,
      cellClassName: 'recommend',
    },
    { field: 'Prior', headerName: t('Prior'), type: 'number', valueFormatter },
    {
      field: 'Operability',
      headerName: t('Operability'),
      type: 'number',
      valueFormatter,
    },
    {
      field: 'Effectiveness',
      headerName: t('Effectiveness'),
      type: 'number',
      valueFormatter,
    },
    {
      field: 'Safety',
      headerName: t('Safety'),
      type: 'number',
      valueFormatter,
    },
    {
      field: 'Economy',
      headerName: t('Economy'),
      type: 'number',
      valueFormatter,
    },
  ];

  return (
    <div style={{ height: 450, minWidth: 800 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={6}
        hideFooterPagination
        components={{
          Footer: CustomFooter,
        }}
      />
      <Radar data={rows} />
    </div>
  );
}

function CustomFooter() {
  let { t } = useTranslation();
  return (
    <div
      style={{
        padding: 10,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
      }}
    >
      <div>
        <div>{t('NoteSLFF')}</div>
        <div>{t('NoteULS')}</div>
      </div>
      <div style={{ color: 'red' }}>{t('dropDownNotice')}</div>
    </div>
  );
}
